import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../lib/routes';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">Farmero</h3>
            <p className="text-sm">
              Pure from the Source. We bring you the freshest organic products directly from local farmers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={ROUTES.HOME} className="hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to={ROUTES.PRODUCTS} className="hover:text-primary-400 transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to={ROUTES.ABOUT} className="hover:text-primary-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CONTACT} className="hover:text-primary-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button className="hover:text-primary-400 transition-colors text-left">
                  FAQ
                </button>
              </li>
              <li>
                <button className="hover:text-primary-400 transition-colors text-left">
                  Shipping Info
                </button>
              </li>
              <li>
                <button className="hover:text-primary-400 transition-colors text-left">
                  Returns
                </button>
              </li>
              <li>
                <button className="hover:text-primary-400 transition-colors text-left">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-sm">
              <li>Email: info@farmero.com</li>
              <li>Phone: +1 (555) 123-4567</li>
              <li>Address: 123 Farm Road, Green Valley, CA 94000</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {currentYear} Farmero. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

